import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";


const Dubai = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Leading salesforce Consultant and Partner in Dubai </title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content="Boost your business with Codezix – experts in Salesforce consulting and implementation in Dubai. Tailored CRM solutions to drive growth and success."
                />
                <meta
                    name="keywords"
                    content="salesforce consultant in Dubai , salesforce consulting in Dubai , salesforce consulting partner in Dubai , salesforce consultants in Dubai, salesforce developer in Dubai"
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Consultant In Dubai</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/country/dubai.webp')} alt="Salesforce consulting Dubai" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <div className='explore-heading text-left'>
                                <h2>Your Trusted Salesforce Consultant in Dubai for Expert Services &amp;
                                    Implementation</h2>
                            </div>
                            <p className="prose-lg wow fadeUp">Unlock the full potential of your CRM with expert Salesforce consulting and implementation
                                services from Codezix, your trusted technology partner in Dubai. As a rapidly growing
                                innovation hub and home to many Fortune 500 companies, Dubai offers the perfect
                                ecosystem for digital transformation. Businesses here are continuously evolving, and having
                                a reliable Salesforce consultant in Dubai is essential for staying ahead in today’s
                                competitive landscape.
                            </p>
                            <p className="prose-lg wow fadeUp">At Codezix, we specialize in delivering customized Salesforce solutions that align with your
                                unique business goals. From strategic consulting to seamless implementation, our certified
                                team works closely with your organization to ensure every step of your Salesforce journey is
                                smooth, effective, and results-driven. We focus on building flexible, scalable, and future-
                                ready solutions that empower your teams, enhance productivity, and streamline workflows.
                            </p>
                            <p className="prose-lg wow fadeUp">Our services cover the full spectrum of Salesforce capabilities — including Sales Cloud,
                                Service Cloud, Marketing Cloud, and Experience Cloud — as well as integrations with third-
                                party systems. Whether you&#39;re new to Salesforce or looking to optimize an existing setup, our
                                experts provide actionable insights and practical solutions that bring measurable value.
                            </p>
                            <p className="prose-lg wow fadeUp">Choosing the right Salesforce consultant in Dubai can make all the difference. With deep
                                industry knowledge and technical expertise, our team helps you leverage Salesforce’s
                                powerful features to improve customer engagement, drive sales performance, and support
                                sustainable growth.
                            </p>
                            <p className="prose-lg wow fadeUp">We don’t just implement systems — we build partnerships. At Codezix, we are committed to
                                your long-term success with continuous support, training, and optimization services designed
                                to keep your CRM aligned with your evolving needs.
                            </p>
                            <p className="prose-lg wow fadeUp">Work with a proven Salesforce consultant in Dubai and experience how strategic guidance,
                                expert implementation, and local insight can transform your business.
                            </p>
                        </div>
                        <div className='cloud-demo' >
                            <div className="explore-heading text-left">
                                <h2>Salesforce Consulting Services in Dubai</h2>
                                <p className="prose-lg">
                                    Looking for expert Salesforce solutions tailored to your business needs? Codezix is your
                                    trusted partner for delivering high-impact Salesforce services in Dubai. Our certified
                                    professionals specialize in helping organizations across various industries transform their
                                    CRM systems, drive efficiency, and accelerate growth through intelligent implementation and
                                    support.
                                </p>
                                <p className="prose-lg">As a hub of innovation and enterprise, Dubai is home to a diverse range of businesses—from
                                    startups to Fortune 500 companies—each requiring flexible, scalable digital solutions. With
                                    deep industry experience and a proven track record, our team understands the unique challenges and opportunities within the regional market. We take a hands-on, consultative
                                    approach to every engagement, ensuring that our strategies align with your goals and deliver
                                    measurable outcomes.</p>
                                <p className="prose-lg">Our Salesforce services include CRM implementation, cloud integration, system
                                    customization, and ongoing support. Whether you&#39;re just beginning your Salesforce journey
                                    or looking to enhance an existing setup, our experts guide you every step of the way. We
                                    ensure a seamless process—from initial consultation to post-deployment support—so you get
                                    the most from your investment.
                                </p>
                                <p className="prose-lg">As a leader in Salesforce consulting in Dubai, we pride ourselves on providing solutions
                                    that go beyond technical implementation. We focus on user adoption, data accuracy,
                                    automation, and customer experience to build systems that truly support business success.
                                </p>
                                <p className="prose-lg">Choosing the right partner for Salesforce consulting in Dubai can make all the difference in
                                    achieving long-term value. At Codezix, we’re committed to delivering excellence,
                                    innovation, and support tailored to your business environment.
                                </p>
                                <p className="prose-lg">Connect with one of our Account Executives today and discover how expert Salesforce
                                    consulting in Dubai can elevate your operations, streamline workflows, and position your
                                    business for sustainable growth.
                                </p>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/consulting.webp')} alt='Salesforce implementation Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Consulting</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our certified consultants assess your business needs, streamline processes, and provide
                                                strategic guidance tailored to your goals. We help resolve common CRM challenges,
                                                including low sales productivity and misalignment between departments, ensuring smoother
                                                operations and improved overall efficiency.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/implementation.webp')} alt='Salesforce implementation Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Implementation</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Elevate your business with our expert implementation services. Our certified professionals
                                                specialize in setting up, customizing, and configuring cloud-based solutions and add-ons,
                                                helping you drive innovation, streamline operations, and accelerate growth with technology
                                                tailored to your unique business needs
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/customization.webp')} alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Customization</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our certified consultants evaluate your business processes to deliver strategic guidance
                                                tailored to your goals. We help overcome CRM challenges, improve sales productivity, and
                                                enhance collaboration across departments, ensuring greater efficiency and smoother
                                                operations throughout your organization.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/development.webp')} alt='CRM solutions Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce App Development</h3>
                                            <p className="wow fadeUp prose-lg">
                                                We bring your app ideas to life with practical, high-impact solutions. Based in Dubai, our
                                                certified developers specialize in creating custom applications and deploying them seamlessly
                                                on leading platforms, ensuring functionality, scalability, and alignment with your business
                                                objectives.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/integration.webp')} alt='Salesforce experts Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Integration</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Break down departmental silos and boost productivity with our seamless integration services. We connect Salesforce CRM with ERP, CMS, DMS, and accounting software, ensuring smooth data flow and enhanced operational efficiency.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/migration.webp')} alt='Salesforce partner Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Migration Services</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Effortlessly migrate from your legacy system with our trusted data migration services in Dubai. Our experts ensure a smooth, secure transition while preserving the accuracy and integrity of your customer data throughout the entire migration process for minimal disruption.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/support.webp')} alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Support</h3>
                                            <p className="wow fadeUp prose-lg">
                                                We continuously monitor your system to detect and resolve issues before they escalate. With proactive oversight, we reduce downtime, maintain smooth operations, and help prevent major disruptions, keeping your business running efficiently and without unexpected interruptions.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='client-section'>
                            <div className='explore-heading text-left'>
                                <h2>Our Certified Salesforce Consulting Team in Dubai</h2>
                                <p className="prose-lg">Our certified team in Dubai is dedicated to delivering tailored solutions that drive business growth and efficiency. With deep expertise across various industries, we help organizations streamline processes, enhance customer engagement, and maximize ROI through strategic CRM implementation and support. While we operate globally, our approach remains locally focused, adapting to the unique needs of businesses in each region. Similar to a trusted Salesforce consulting partner in Dubai, we combine technical excellence with industry insight to deliver lasting results. Partner with a team that understands your challenges and provides real solutions that scale with your success.</p>
                            </div>
                            <div className='row top'>
                                <Swiper
                                    breakpoints={{
                                        425: {
                                            slidesPerView: 2,
                                            spaceBetween: 10,
                                        },
                                        640: {
                                            slidesPerView: 3,
                                            spaceBetween: 10,
                                        },
                                        768: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 5,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination, Autoplay]}
                                    className="testimonialSwiper-client"
                                >
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/4.webp" alt='Salesforce implementation dubai' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/2.webp" alt='CRM solutions dubai' />
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/3.webp" alt='Salesforce experts dubai' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/5.webp" alt='Salesforce partner dubai' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/6.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/7.webp" alt='Salesforce consulting dubai' />
                                        </div>
                                    </SwiperSlide>

                                </Swiper>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Consultants in Dubai – Experts in Salesforce Clouds</h2>
                                <p className="wow fadeUp prose-lg text-left">
                                    Our team of certified professionals delivers expert solutions across all major Salesforce Clouds, including Sales, Service, Marketing, and Experience Cloud. We work closely with businesses to customize and implement strategies that streamline operations, improve customer relationships, and drive growth. As leading Salesforce consultants in Dubai, we understand the unique challenges of the regional market and deliver solutions tailored to each industry’s needs. From automation to advanced analytics, our team ensures your Salesforce platform is fully optimized. Trust our experienced Salesforce consultants in Dubai to help you unlock the full potential of your cloud investment.
                                </p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-dubai#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/einstein-analytics">
                                            <h3 class="mt-0">Einstein Analytics</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-dubai#">
                                            <h3 class="mt-0">Salesforce Lightning</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-dubai#">
                                            <h3 class="mt-0">Health Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-center'>
                                <h2>Industries We Serve</h2>
                            </div>

                            <div class="row mob-imagebox">
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/healthcare.webp" alt="Salesforce implementation Dubai" />
                                        <div class="image-text">
                                            <p>Healthcare</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/retail.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>E-Commerce</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/logistics.webp" alt="CRM solutions Dubai" />
                                        <div class="image-text">
                                            <p>Logistics</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/financial.webp" alt="Salesforce experts Dubai" />
                                        <div class="image-text">
                                            <p>Financial</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/manufacturing.webp" alt="Salesforce partner Dubai" />
                                        <div class="image-text">
                                            <p>Manufacturing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/publicsector.webp" alt="Custom Salesforce solutions" />
                                        <div class="image-text">
                                            <p>Public Sector</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/media.webp" alt="Salesforce consulting Dubai" />
                                        <div class="image-text">
                                            <p>Media</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/it.webp" alt="Salesforce implementation Dubai" />
                                        <div class="image-text">
                                            <p>IT Industry</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/telecom.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>Telecom</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/education.webp" alt="CRM solutions Dubai" />
                                        <div class="image-text">
                                            <p>Education</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Industries We Serve – Powered by Salesforce Developers in Dubai</h2>
                                <p className="prose-lg">Our team of skilled Salesforce developers in Dubai provides tailored solutions to a wide range of industries, including retail, healthcare, finance, manufacturing, and more. We help businesses optimize their Salesforce platforms to improve efficiency, enhance customer relationships, and drive growth. With extensive experience in developing customized Salesforce applications, our Salesforce developers in Dubai ensure that your systems align perfectly with your specific industry requirements. Whether it’s automating sales processes, streamlining customer service, or improving marketing campaigns, we deliver powerful solutions that bring measurable value and long-term success to your organization.</p>
                            </div>
                            <div className="row bottom">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Certified Salesforce Consulting Partner</li>
                                            <li className="wow fadeUp prose-lg">80+ expert developers with 300+ certifications</li>
                                            <li className="wow fadeUp prose-lg">89% repeat business rate, reflecting client trust</li>
                                            <li className="wow fadeUp prose-lg">90% client retention rate for long-term success</li>
                                            <li className="wow fadeUp prose-lg">Over a decade of industry experience</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Ongoing Support & Maintenance</li>
                                            <li className="wow fadeUp prose-lg">24/7 global Salesforce support across all time zones</li>
                                            <li className="wow fadeUp prose-lg">100% in-house code development for superior quality control</li>
                                            <li className="wow fadeUp prose-lg">99% on-time project delivery for seamless execution</li>
                                            <li className="wow fadeUp prose-lg">Rigorous testing ensures reliable and efficient Salesforce solutions</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/pd1.webp" alt='Salesforce experts Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">3 PL Central </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Headquartered in California, our client <strong>3PL Central</strong> offers a warehouse management system (WMS) that optimizes operations, enhances customer satisfaction, and drives business growth.
                                            </p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/24-Fit-Club1.webp" alt='Salesforce partner Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">24 Fit Club </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in the UK, <strong>24 Fit Club</strong> is a passionate fitness community dedicated to health and well-being. Their expert team delivers top-tier fitness advice, online classes, and the latest insights to empower clients and promote body positivity.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/salesforce1.webp" alt='Salesforce experts Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Active Campaign </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Salesforce is a leading CRM solution, providing a powerful enterprise application compatible across multiple devices. With a robust app marketplace, it strengthens marketing and sales alignment, driving better leads and high-quality pipelines.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/advologix.webp" alt='Salesforce partner Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Advologix</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in Sugarland, Texas, Advologix is a digital consultancy specializing in legal document and case management. They help law firms, legal departments, and public service organizations streamline case processing with centralized information management systems.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/concert_health.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Concert Health</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Concert Health helps physician practices integrate behavioral health services, offering care management, brief therapy, and psychiatric consultations. With expert clinicians, industry expertise, and advanced technology, they enhance patient care and outcomes.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/at-home-solutions.webp" alt='Salesforce consulting Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">At Home Solutions</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in Dubai, At Home Solutions delivers personalized healthcare services to enhance quality of life for all ages. With over a decade of experience, they provide affordable, effective care, offering companionship, tailored services, and essential support.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/commerce.webp" alt='Salesforce implementation Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Commerce Cloud: Everything You Need to Know </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today’s digital era, e-commerce is crucial for business success, fueling intense competition. As online shopping demand rises, businesses must embrace robust, scalable solutions to stay ahead and meet evolving consumer expectations.
                                            </p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/agent.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Ultimate Guide to Salesforce Agentforce</h3>
                                            <p className="wow fadeUp prose-lg">
                                                The big highlight of 2024 is Salesforce Agentforce. On Day Three of Dreamforce 2024, Salesforce unveiled the third wave of AI, introducing Agentforce—a groundbreaking tool designed to enhance employee productivity with advanced AI capabilities.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/marketing.webp" alt='CRM solutions Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                What is Salesforce Mulesoft & How Codezix Can Assist with Implementation & Customization
                                            </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today’s digital landscape, businesses rely on multiple applications and platforms to enhance operations and customer experiences. However, seamless integration remains a challenge—this is where Salesforce Mulesoft comes in...
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Dubai;